import { RecordType, properCase } from '@petconsole/pure-base';
import { AnyAsyncThunk } from '../../types/types';
import { useOurDispatchValue, useOurSelectAction } from '../hooks';
import { slicePropertySelector } from '../selectors';

const slicePropertyHooks = (sliceName: string, propertyName: string, actions: RecordType) => {
  const pascalName = properCase(propertyName);
  const hooks: RecordType = {};

  hooks[`useOurSelect${pascalName}`] = () =>
    useOurSelectAction(slicePropertySelector(sliceName, propertyName));
  hooks[`useOurSet${pascalName}`] = () => useOurDispatchValue(actions[`set${pascalName}`] as AnyAsyncThunk);

  return hooks;
};

export default slicePropertyHooks;
